var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('EmployeeHeader',{attrs:{"title":"Detalle de Empleado"}}),_c('EmployeeForm',{attrs:{"employee":_vm.employee},on:{"onUpdate":_vm.onUpdate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }